import React, { Children } from 'react'
import PropTypes from 'prop-types'
import styles from './styles'

const WorkAuthList = ({ children }) => (
  <ul className={styles.list}>
    {Children.map(children, child => (
      <li className={styles.listItem}>{child}</li>
    ))}
  </ul>
)

WorkAuthList.propTypes = {
  children: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.array, PropTypes.shape()])),
}
export default WorkAuthList
